// src/form-utils.tsx
import { cx } from "class-variance-authority";
import { jsx, jsxs } from "react/jsx-runtime";
var HintsAndErrorMessage = ({
  hasHint,
  hintId,
  hint,
  errorId,
  hasError,
  errorMessage,
  disabled = false
}) => /* @__PURE__ */ jsxs("span", { className: cx("mt-1 grid", { "mb-2": hasHint || hasError }), children: [
  hasHint ? /* @__PURE__ */ jsx(
    "span",
    {
      className: cx("text-xs", {
        "text-interactive-disabled": disabled,
        "text-surface-body": !disabled
      }),
      id: hintId,
      children: hint
    }
  ) : null,
  hasError ? /* @__PURE__ */ jsx(
    "span",
    {
      className: cx("text-xs", {
        "mt-2": hasHint,
        "text-interactive-disabled": disabled,
        "text-state-negative-text": !disabled
      }),
      id: errorId,
      children: errorMessage
    }
  ) : null
] });
var Label = ({
  labelId,
  hideLabel,
  text,
  disabled,
  className = ""
}) => /* @__PURE__ */ jsx(
  "label",
  {
    className: cx(`w-fit text-sm ${className}`, {
      "sr-only": hideLabel,
      "text-interactive-disabled": disabled,
      "text-surface-dark": !disabled
    }),
    htmlFor: labelId,
    children: text
  }
);

export {
  HintsAndErrorMessage,
  Label
};
